<ul [hidden]="!visible">
  @for (level of levelsAsRange; track level) {
  <li>
    <icon [class.highlighted]="level <= strength" type="lock-fill"></icon>
  </li>
  }
</ul>
